export default __webpack_public_path__ + "static/media/power_ratio_norm.31f506d7.webp";